"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPing = exports.networkReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    pingMs: 0,
    lastPingTimestamp: 0,
};
_a = (0, toolkit_1.createSlice)({
    name: "network",
    initialState,
    reducers: {
        setPing: (state, { payload: ping }) => {
            state.pingMs = ping;
            state.lastPingTimestamp = Date.now();
        },
    },
}), exports.networkReducer = _a.reducer, exports.setPing = _a.actions.setPing;
